import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="logo-wrap">
          <Link to="/" onClick={toTop} className="logo-link">
            Boventraix
          </Link>
        </div>

        <div className="header-icons">
          <Link
            onClick={toTop}
            to="/cartpage"
            className="icon-btn cart-btn"
            aria-label="Cart"
            title="Cart"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 6H21L20 12H8L6 6Z"
                stroke="#111"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="9" cy="19" r="1" fill="#111" />
              <circle cx="18" cy="19" r="1" fill="#111" />
            </svg>
            <span className="cart-count" aria-hidden="true">
              {cartItems.length}
            </span>
          </Link>
        </div>
      </div>

      <nav className="header-nav">
        <ul className="nav-links">
          <li>
            <Link onClick={toTop} to="/shop">
              Sale
            </Link>
          </li>
          <li>
            <Link onClick={toTop} to="/about">
              Our Story
            </Link>
          </li>
          <li>
            <Link onClick={toTop} to="/contact">
              Contact Us
            </Link>
          </li>
        </ul>

        <div className="promo-bar" role="region" aria-label="Promotions">
          <div className="promo-item promo-large">
            UP TO 80% OFF EVERYTHING!*
          </div>
          <div className="promo-item promo-middle">UP TO 75% OFF BRANDS!*</div>
          <div className="promo-item promo-small">25% OFF DSGN!*</div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
